import { useDispatch } from "react-redux";
import { updateTranscriptModalState } from "../../../Shared/PopUpModals/Actions";
import { fetchTranscript } from "../../Video/VideoActions";
import { formatTime, timeInSeconds } from "../../../utilities";

const SupportingData = ({ data }) => {
  const dispatch = useDispatch();

  const renderSupportingData = (supportingData) => {
    return supportingData?.map((item, index) => {
      const {
        _id,
        thumbnail_url,
        db_id,
        start_ts,
        source_doc,
        source_doc_type,
      } = item;
      return db_id ? (
        <div className="supporting-details" key={index}>
          <div className="vid-thumb">
            <img
              role="button"
              src={
                thumbnail_url
                  ? thumbnail_url
                  : require("@src/assets/images/vyrill/default.png").default
              }
              alt="Thumbnail"
              onClick={() => {
                dispatch(fetchTranscript([db_id]));
                dispatch(
                  updateTranscriptModalState({
                    videoId: db_id,
                    shouldOpen: true,
                    videoStartAt: timeInSeconds(formatTime(start_ts)),
                    pinTime: formatTime(start_ts),
                    pinSentence: source_doc,
                  })
                );
              }}
            />
          </div>
          <div className="time-stamp">{formatTime(start_ts)}</div>
          <div className="description">
            {source_doc?.split("\n").map((line, index) => (
              <p key={index}>{line}</p>
            ))}
          </div>
        </div>
      ) : null;
    });
  };

  if (data?.supporting_data) {
    return renderSupportingData(data?.supporting_data);
  } else null;
};

const AnswerRow = ({ k }) => {
  return (
    <div className="answer-section d-flex" style={{ marginBottom: "53px" }}>
      <div className="ask-vyrill-logo">
        <img
          src={require("@src/assets/images/vyrill/ask_vyrill.png").default}
          alt=""
          width="23px"
        />
      </div>
      <div className="chat-answer">
        {/* <div>{k?.content}</div> */}
        <div>
          {k?.content?.split("\n").map((line, index) => (
            <span key={index}>{line}</span>
          ))}
        </div>
        <SupportingData data={k} />
      </div>
    </div>
  );
};
export default AnswerRow;
